<template>
  <div>
    <v-row>
      <div class="terms pl-4 pr-4 pt-4">
        <sc-rich-text class="sc-terms" :field="termsAndConditions.TermsAndConditionsContent" />
      </div>
    </v-row>
    <v-row>
      <v-col class="pa-0 pt-12 text-right">
        <v-btn class="mb-4 btn-secondary" v-on:click.native="logout" tile outlined large color="#00629B">
          <sc-text :field="termsAndConditions.DeclineButton" />
        </v-btn>
        <v-btn
          id="accept"
          class="mb-4 ml-6 btn-primary"
          v-on:click.native="acceptTermsAndConditions"
          :loading="loading"
          tile
          large
          color="#00629B"
          dark
        >
          <sc-text :field="termsAndConditions.AcceptButton" />
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { RichText, Text } from '@sitecore-jss/sitecore-jss-vue';
import { acceptTermsAndConditions } from '../../api/';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import { removeCorrelationId } from '../../lib/UserSession.js';

export default {
  name: 'SubsetView',
  components: {
    ScRichText: RichText,
    ScText: Text,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: ['termsAndConditions'],
  methods: {
    async acceptTermsAndConditions() {
      this.loading = true;
      try {
        const response = await acceptTermsAndConditions();
        if (response.success) {
          this.$router.push({ path: '/' });
        }
      } catch (error) {
        this.loading = true;
        apiErrorHelper(this.$router, error);
      }
    },
    async logout() {
      await this.$auth.logout();

      // this will also remove the Correlation ID use for debugging
      removeCorrelationId();
    },
  },
};
</script>
<style>
@media print {
  h1,
  h2,
  h3,
  p,
  ul {
    margin-bottom: 1rem;
  }
}
</style>
<style lang="scss" scoped>
.v-label {
  margin-bottom: 8px !important;
}
.theme--light.v-input--selection-controls {
  margin-top: 8px !important;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: map-deep-get($colors, 'link-disabled', 'base') !important;
  opacity: 0.6 !important;
  color: map-deep-get($colors, 'white', 'base') !important;
}
.terms {
  width: 100%;
  height: 60vh;
  background-color: map-deep-get($colors, 'white', 'base');
  border: map-deep-get($colors, 'grey-lightest', 'base') 1px solid;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  overflow-y: scroll;
  overflow-x: hidden;
  word-break: break-word;
  max-width: 576px;
  &::v-deep {
    h1,
    h2,
    h3,
    p,
    ul {
      margin-bottom: 0.8rem;
      color: map-deep-get($colors, 'blue-text', 'base');
    }
    h1 {
      font-weight: map-get($font-weights, 'medium');
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 1.375rem;
      }
    }
    h2 {
      font-size: 1.75rem;
      font-weight: map-get($font-weights, 'medium');
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 1.25rem;
      }
    }
    p:first-of-type {
      font-size: 12px;
    }
  }
}
</style>
